module.exports = __webpack_public_path__ + "static/media/section2.02f649b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/section2.png
// module id = 298
// module chunks = 0